export default class GetPaymentInfoResponseBody {
  public guid: string;
  public initiationCode: string;
  public status: string;
  public initiateUrl: string;

  constructor(data: Record<string, unknown>) {
    this.guid = data.guid as string;
    this.initiationCode = data.initiation_code as string;
    this.status = data.status as string;
    this.initiateUrl = data.initiate_url as string;
  }
}
